export enum LocationType {
  STOCK = 'STOCK',
  PROJECT = 'PROJECT',
  CONSUMED = 'CONSUMED',
}
